import { paths, routes } from "config/paths";
import { useMemo } from "react";
import { useWebRouter } from "~utils/next-router/use-web-router";

import {
	SideNav,
	SideNavProps,
} from "~ui-components/components/molecules/side-nav";

export function LayerSettingsSideNav() {
	const router = useWebRouter();

	const navItems = useMemo<SideNavProps["navItems"]>(() => {
		const accountName = router._query.accountName!;
		const mapId = router._query.mapId!;
		const mapName = router._query.mapName!;
		const layerId = router._query.layerId!;

		return [
			{
				items: [
					{
						title: "Layer details",
						href: paths.accountName.maps.mapId.mapName.layers.layerId.details(
							accountName,
							mapId,
							mapName,
							layerId,
						),
						matcher: {
							type: "equals",
							href: routes.accountName.maps.mapId.mapName.layers.layerId
								.details,
						},
					},
					{
						title: "Layer style",
						href: paths.accountName.maps.mapId.mapName.layers.layerId.style(
							accountName,
							mapId,
							mapName,
							layerId,
						),
						matcher: {
							type: "equals",
							href: routes.accountName.maps.mapId.mapName.layers.layerId.style,
						},
					},
					{
						title: "Label",
						href: paths.accountName.maps.mapId.mapName.layers.layerId.label(
							accountName,
							mapId,
							mapName,
							layerId,
						),
						matcher: {
							type: "equals",
							href: routes.accountName.maps.mapId.mapName.layers.layerId.label,
						},
					},
					{
						title: "Popup",
						href: paths.accountName.maps.mapId.mapName.layers.layerId.popup(
							accountName,
							mapId,
							mapName,
							layerId,
						),
						matcher: {
							type: "equals",
							href: routes.accountName.maps.mapId.mapName.layers.layerId.popup,
						},
					},
					{
						title: "Attribute format",
						href: paths.accountName.maps.mapId.mapName.layers.layerId.attributeFormatting(
							accountName,
							mapId,
							mapName,
							layerId,
						),
						matcher: {
							type: "equals",
							href: routes.accountName.maps.mapId.mapName.layers.layerId
								.attributeFormatting,
						},
					},
				],
			},
		];
	}, [router.query]);

	return <SideNav navItems={navItems} />;
}
